'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _DefaultString = require('../../helpers/DefaultString');

var _Product = require('../../helpers/Product');

var _NotFound = require('./NotFound.scss');

var _NotFound2 = _interopRequireDefault(_NotFound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NotFound, _Component);

  function NotFound() {
    (0, _classCallCheck3.default)(this, NotFound);
    return (0, _possibleConstructorReturn3.default)(this, (NotFound.__proto__ || (0, _getPrototypeOf2.default)(NotFound)).apply(this, arguments));
  }

  (0, _createClass3.default)(NotFound, [{
    key: 'render',
    value: function render() {
      var productClassName = (0, _Product.getProductClassName)(this.props.auth.realm, this.props.auth.productName, this.props.auth.clientId);
      return _react2.default.createElement(
        'div',
        { className: [_NotFound2.default.notFoundComponent, productClassName].join(' ') },
        _react2.default.createElement('div', { className: _NotFound2.default.background }),
        _react2.default.createElement(
          'div',
          { className: _NotFound2.default.content },
          _react2.default.createElement(
            'div',
            { className: _NotFound2.default.title },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.NotFoundTitle)
          ),
          _react2.default.createElement(
            'div',
            { className: _NotFound2.default.subtitle },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.NotFoundSubTitle)
          ),
          _react2.default.createElement(
            'ul',
            { className: _NotFound2.default.reasons },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.NotFoundReason1)
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.NotFoundReason2)
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.NotFoundReason3)
            )
          )
        )
      );
    }
  }]);
  return NotFound;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object
}, _temp)) || _class);
exports.default = NotFound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/NotFound.js
// module id = 2013
// module chunks = 0